import type { MapElemInfo } from 'src/models';
import type { Ref } from 'vue';

type SwitchGeoItemEmitFn<T> = (event: 'show-previous-geo-item' | 'show-next-geo-item', elem: MapElemInfo<T>) => void;

export default function useSwitchGeoItem<T>(emit: SwitchGeoItemEmitFn<T>, elem: Ref<MapElemInfo<T>>): {
  showPrevious: () => void;
  showNext: () => void;
} {
  const showPrevious = () => {
    emit('show-previous-geo-item', elem.value);
  };
  const showNext = () => {
    emit('show-next-geo-item', elem.value);
  };

  return {
    showPrevious,
    showNext,
  };
}
